import React, { useState, useEffect } from "react";
import axios from "axios";
import { useUser } from "../../Home/UserContext";
import DashboardNavigation from "./../../DashboardNavigation/DashboardNavigation";
import useScrollToTop from "./../../../hooks/useScollToTop";
import { getRoleFromRoleId } from "../../../utils/roleHelper";

const ProgressPhasePage = () => {
  useScrollToTop();
  const { user } = useUser();
  const role = getRoleFromRoleId(user?.role_id);
  const ASSO_ID = process.env.REACT_APP_ASSO_ID;

  const [phases, setPhases] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchPhases = async () => {
    try {
      const response = await axios.get(
        `https://api.monappliclub.com/api/progressTracking/AllProgressStepsByAssociationId/${ASSO_ID}`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );
      if (Array.isArray(response.data)) {
        setPhases(response.data);
      } else {
        throw new Error("Les données reçues ne sont pas un tableau.");
      }
    } catch (error) {
      console.error("Erreur lors du chargement des étapes :", error);
    } finally {
      setLoading(false);
    }
  };
  

  useEffect(() => {
    fetchPhases();
  }, []);

  return (
    <div className="flex flex-col w-full mx-auto p-2 mt-[130px] sm:mt-[130px] md:mt-[150px] lg:mt-[150px] xl:mt-[150px] dark:text-white">
      <h2 className="text-xl sm:text-2xl md:text-3xl lg:text-4xl font-light tracking-[0.4em] text-gray-800 text-center dark:text-white mb-4">
        ADMINISTRATEUR
      </h2>
      <h2 className="text-xl sm:text-2xl md:text-3xl lg:text-4xl font-bold tracking-widest text-gray-800 text-center dark:text-white mb-4 font-montserrat uppercase">
        Progression dans les étapes
      </h2>

      <DashboardNavigation role={role} />

      <div className="text-center p-4 bg-blue-100 rounded-lg shadow max-w-[800px] mx-auto mb-4 dark:text-gray-800">
        <p className="text-lg font-semibold mb-2">
          Suivi d'avancement de votre application
        </p>
        <p className="text-sm text-left">
          Cette page vous permet de suivre les différentes étapes de votre
          site/application. Chaque étape à valider est affichée ci-dessous :
        </p>
        <p className="text-sm text-left mt-2">
          🟢 Étape validée&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;🔴 Étape à
          finaliser
        </p>
        <p className="text-sm text-left mt-1">
          Ces étapes peuvent être réalisées par vous-même ou par vos équipes.
        </p>
      </div>

      {/* Barre de progression globale */}
      {phases.length > 0 && (
        <div className="max-w-[800px] mx-auto mb-8">
          <h3 className="text-center text-lg font-semibold mb-2 text-gray-800 dark:text-white">
            Avancement global de l’installation
          </h3>
          <div className="w-full bg-gray-300 dark:bg-gray-700 rounded-full h-6 overflow-hidden shadow-inner">
            <div
              className="h-full bg-gradient-to-r from-green-300 to-green-700 transition-all duration-700 ease-in-out"
              style={{
                width: `${
                  Math.round(
                    (phases.filter((p) => p.is_done).length / 16) * 100
                  ) || 0
                }%`,
              }}
            />
          </div>
          <p className="text-center mt-2 text-xl font-bold text-green-700 dark:text-green-400">
            {Math.round((phases.filter((p) => p.is_done).length / 16) * 100)}%
          </p>
        </div>
      )}

      <div className="max-w-[800px] mx-auto bg-white shadow-md rounded-lg p-4 space-y-2 dark:bg-gray-800">
        {loading ? (
          <p>Chargement en cours...</p>
        ) : Array.isArray(phases) && phases.some((p) => p.ProgressPhase) ? (
          phases
            .filter((p) => p.ProgressPhase) // sécurité : n’affiche que celles qui ont bien ProgressPhase défini
            .sort((a, b) => a.ProgressPhase.ordre - b.ProgressPhase.ordre)
            .map((item) => (
              <div
                key={item.id}
                className="flex items-center justify-between border-b py-2"
              >
                <span className="text-sm sm:text-base dark:text-white">
                  {item.ProgressPhase.phase}
                </span>
                <span
                  className={`text-3xl ${
                    item.is_done ? "text-green-600" : "text-red-600"
                  }`}
                >
                  {item.is_done ? "🟢" : "🔴"}
                </span>
              </div>
            ))
        ) : (
          <p className="text-center">
            Aucune étape trouvée pour cette association.
          </p>
        )}
      </div>
    </div>
  );
};

export default ProgressPhasePage;
